import * as theme from "../theme";

import { useContext, useState } from "react";

import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import CustomInput from "../components/inputs/CustomInput";
import InputContainer from "../components/inputs/InputContainer";
import Context from "../contexts/data";
import { handleRedirection } from "../util/httpHelpers";
import { checkValid } from "../util/reverseRequiredInfo";

const ZipCode = ({ offer }) => {
  const { navigate, zipCode, handleUpdateFormValue, errorMessage } =
    useContext(Context);

  const [buttonText, setButtonText] = useState("Next");

  const handleUpdate = ({ target }) => {
    const { value } = target;
    const sanitizedValue = value.replace(/[^0-9]/g, "").slice(0, 5);

    handleUpdateFormValue("zipCode", sanitizedValue);

    if (sanitizedValue.length === 5) {
      handleUpdateFormValue("errorMessage", "");
    }
  };

  const handleNextStep = async () => {
    if (!zipCode || zipCode.length < 5 || errorMessage) {
      handleUpdateFormValue(
        "errorMessage",
        "Please enter a valid 5 digit zip code."
      );
      return;
    } else if (offer) {
      handleRedirection("Longbridge offer");
    } else {
      setButtonText("Validating Zip Code");

      const { isValidState, redirect } = await checkValid(
        handleUpdateFormValue,
        zipCode
      );

      if (isValidState) {
        setButtonText("Next");
        navigate("home-value", "Zip");
      } else {
        setButtonText(redirect ? "Redirecting..." : "Next");

        if (redirect) {
          handleRedirection("state");
        }
      }
    }
  };

  return (
    <Wrapper>
      <HeaderText bigger_text={"What's the property zip code?"} />
      <InputContainer inputClass={"genericContainer"}>
        <CustomInput
          placeholder="Enter property Zip Code"
          value={zipCode}
          onChange={handleUpdate}
          errorMessage={errorMessage}
          fieldClass="genericInput"
          name={"zipcode"}
          labelName={"Zip Code"}
        />
      </InputContainer>
      <ErrorMessage />
      <Button
        onClick={handleNextStep}
        text={buttonText}
        disabled={buttonText === "Validating Zip Code"}
      />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  transform: translateY(0px);
`;

export default ZipCode;
